<template>
    <div>
        <ProgressBar :currentStepIndex="3" />

        <div class="contentblock">
            <section class="contentblock__content">
                <div class="pneu-offer__fieldgroup">
                    <div class="pneu-offer__fieldgroup-title">{{strings['PneuOffer.SummaryTitle']}}</div>
                    <div class="pneu-offer__summary-intro" v-html="strings['PneuOffer.SummaryIntro']"></div>

                    <div class="pneu-offer__promos" v-if="settings['PneuPromotions'].length > 0">
                        <div class="pneu-offer__promo" v-for="promo in settings['PneuPromotions']" :key="promo.Name">
                            <strong>{{promo.Name}}</strong><br />
                            {{promo.Description}}
                        </div>
                    </div>

                    <strong>{{strings['PneuOffer.SummaryTyreTitle']}}</strong>
                    <SelectedTyre />

                    <div class="pneu-offer__summary">
                        <div class="pneu-offer__summary-block">
                            <strong>{{strings['PneuOffer.Services']}}</strong>
                            <div class="pneu-offer__summary-bg">
                                <p v-if="bookedServices.length == 0">{{strings['PneuOffer.NoServices']}}</p>
                                <table cellpadding="0" cellspacing="0" border="0" v-if="bookedServices.length > 0" class="pneu-offer__summary-table">
                                    <tr v-for="service in bookedServices" :key="service.ID">
                                        <td>{{service.Title}}</td>
                                        <td>{{getServicePrice(service) | formatPrice}} {{strings['PneuOffer.PerPiece']}}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="pneu-offer__summary-block">
                            <strong>{{strings['PneuOffer.SummaryStation']}}</strong>
                            <div class="pneu-offer__summary-bg">
                                <p v-html="selectedStationAddressHtml"></p>
                            </div>
                        </div>
                        <div class="pneu-offer__summary-block">
                            <strong>{{strings['PneuOffer.EnterAddress']}}</strong>
                            <div class="pneu-offer__summary-bg">
                                <div v-if="address.salutation === salutations.Mr">{{strings['Enums.Salutation.Mr']}}<br />{{address.firstName}} {{address.lastName}}</div>
                                <div v-if="address.salutation === salutations.Mrs">{{strings['Enums.Salutation.Mrs']}}<br />{{address.firstName}} {{address.lastName}}</div>
                                <div v-if="address.salutation === salutations.Company">{{address.companyName}}</div>
                                <div v-if="address.street">{{address.street}} {{address.streetNumber}}</div>
                                <div v-if="address.addressLine2">{{address.addressLine2}}</div>
                                <div v-if="address.city">{{address.zipcode}} {{address.city}}</div>
                                <br />
                                <div v-if="address.phone">{{strings['Global.Address.Phone']}}:<br />{{address.phone}}<br /><br /></div>
                                <div v-if="address.emailAddress">{{strings['Global.Address.Email']}}:<br />{{address.emailAddress}}</div>
                            </div>
                        </div>
                        <div v-if="remarks.trim() != ''" class="pneu-offer__summary-block">
                            <strong>{{strings['PneuOffer.Remarks']}}</strong>
                            <div class="pneu-offer__summary-bg">
                                <p style="white-space:pre-wrap;">{{remarks}}</p>
                            </div>
                        </div>
                    </div>
                </div>                
                <div class="pneu-offer__fieldgroup pneu-offer__fieldgroup--buttons">
                    <div class="pneu-offer__nav-buttons">
                        <button @click="back()" class="migrol-form__button" :disabled="isGetOfferPending">{{strings['Global.Back']}}</button>
                        <AjaxButton @buttonClick="next()" cssclass="migrol-form__button--green" :label="strings['PneuOffer.ButtonGetOffer']" :isWaitingForAjax="isGetOfferPending" />
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import ProgressBar from './_common/ProgressBar';
    import SelectedTyre from './_common/SelectedTyre';
    import { Salutations } from '@/utils/constants';
    import * as gaTracking from "@/utils/gaTracking";

    export default {
        data() {
            return {
                salutations: Salutations,
                isGetOfferPending: false
            }
        },
        computed: {
            ...mapState([
                'strings',
                'settings',
                'selectedTyre',
                'tyreAmount',
                'remarks',
                'carType',
                'rimType',
                'selectedStationId'
            ]),
            ...mapGetters([
                'address'
            ]),
            bookedServices() {
                return this.settings['Services'].filter(s => s.IsBookable && s.IsBooked);
            },
            selectedStationAddressHtml() {
                return this.settings['AvailableStations'].find(s => s.id == this.selectedStationId).htmlAddress;
            }
        },
        methods: {
            back() {
                this.$router.push('/step3').catch(() => { });
            },
            async next() {

                this.isGetOfferPending = true;

                const data = {
                    station: this.selectedStationId,
                    tyre: this.selectedTyre.EAN,
                    amount: this.tyreAmount,
                    carType: this.carType,
                    rimType: this.rimType,
                    services: this.settings['Services'].filter(s => s.IsBookable === true && s.IsBooked === true).map(s => s.ID),
                    remarks: this.remarks,
                    address: this.address
                };

                const response = await fetch(
                    `/migrolapi/${window.CONFIG.language}/createpneuoffer`,
                    {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(data)
                    }
                );

                const result = await response.json();

                this.isGetOfferPending = false;

                if (result.success) {
                    gaTracking.trackPurchase(this.$store.state);
                    this.$router.push('/step5').catch(() => { });
                } else {
                    alert("An error occurred.");
                }
            }
        },
        mounted() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        components: {
            ProgressBar,
            SelectedTyre
        }
    };
</script>